<div class="col-md-8">
    <div class="row">
        <div class="col-md-12">
            <div class="post-135 page type-page status-publish hentry">
                <div class="widget-main">
                    <div class="widget-inner">
                        <h3 class="archive-title">Passwort vergessen</h3>

                        <form [formGroup]="formular" (ngSubmit)="erzeugePasswortReset()" role="form"
                              class="form-horizontal register-form">
                            <div class="form-group">
                                <label class="col-sm-2 control-label">Email Adresse</label>
                                <div class="col-sm-8">
                                    <input pInputText formControlName="emailAdresse" class="ms-form-text"
                                           type="email"
                                    >
                                </div>
                            </div>

                            <div class="form-group">
                                <div>
                                    <input [disabled]="!formular.valid" class="btn btn-primary" type="submit"
                                           value="Neues Passwort anfordern">
                                </div>
                            </div>

                        </form>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
